const SearchThemes = {
    Light: {
        background: 'sf-white',
        backgroundHover: 'sf-gray-50',
        text: 'sf-gray-800',
        placeholder: 'sf-gray-400',
        iconDisabled: 'sf-gray-300',
        icon: 'sf-gray-500'
    },

    Dark: {
        background: 'sf-gray-900',
        backgroundHover: 'sf-gray-800',
        text: 'sf-white',
        placeholder: 'sf-gray-500',
        iconDisabled: 'sf-gray-600',
        icon: 'sf-gray-300'
    }
};

export default SearchThemes;
